module.exports = __webpack_public_path__ + "static/google-calendar-8297cf2cf2a9fc56bd612112f636de30.svg";